import { AlertMessageService } from '@sigepe/sigepe-template';
import { ConsultaRESTBaseService } from './consulta-restbase.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HistoricoTramitacaoProcessoService extends ConsultaRESTBaseService {
    constructor(alertaMsgService: AlertMessageService, http: HttpClient) {
        super(alertaMsgService, http);
    }

    public obterTramitacaoFerias(idferias: string): Observable<any> {
        return super.get(`/tramitacao-processo-ferias/ferias/${idferias}`);
    }

    public obterHistoricoTramitacao(rev: string, idferias: string): Observable<any> {
        return super.get(`/tramitacao-processo-ferias/tramitacao-com-historico/${rev}/${idferias}`);
    }
}
